import { ITEM_TYPES } from 'constants/itemType';
import { Link } from 'react-router';
import { CorporateViewTabs } from '../../CorporateViewTabGroup';
import { UserNotificationWithDetails } from 'hooks/useUserNotifications';
import { SitrepViewTabs } from 'components/Reports/reports.types';
import { useSitrepsPendingReview } from 'components/DisasterGPT/hooks/useSitrepsV2';

const ReviewRequestedLink: React.FC<UserNotificationWithDetails> = ({
  sourceItemId,
  sourceItemType,
  incidentId,
}) => {
  const sitrepTab = SitrepViewTabs.Drafts;
  // Fetch pending reviews to look up the sitrep's incident_id / aor_id.
  // The notification's incidentId can be null even when the sitrep belongs to
  // an incident, so we fall back to the sitrep's own incident_id here.
  const { data: pendingReviews = [] } = useSitrepsPendingReview(
    sourceItemId === ITEM_TYPES.Sitrep
  );

  let linkUrl: string;

  switch (sourceItemType) {
    case ITEM_TYPES.Sitrep: {
      const matchingSitrep = pendingReviews.find(
        (s) => s.item_id === sourceItemId
      );
      const effectiveIncidentId =
        incidentId || matchingSitrep?.incident_id || null;
      const effectiveAorId = matchingSitrep?.aor_id || null;

      if (effectiveIncidentId) {
        // Navigate directly to the incident's reports page so ReportsView
        // picks up the incident context automatically.
        linkUrl = `/iap/${effectiveIncidentId}/reports?sitrepTab=${sitrepTab}&openReport=${sourceItemId}`;
      } else if (effectiveAorId) {
        // Hub route: include aorId so ReportsView pre-selects the correct filter.
        linkUrl = `/hub?openTab=${CorporateViewTabs.Reports}&sitrepTab=${sitrepTab}&openReport=${sourceItemId}&aorId=${effectiveAorId}`;
      } else {
        // Fallback: hub without a scope filter (sitrep data not yet cached).
        linkUrl = `/hub?openTab=${CorporateViewTabs.Reports}&sitrepTab=${sitrepTab}&openReport=${sourceItemId}`;
      }

      return <Link to={linkUrl}>Go to Report</Link>;
    }
    case ITEM_TYPES.ResourceRequest:
      if (incidentId) {
        linkUrl = `/iap/${incidentId}?openTab=${CorporateViewTabs.Resources}&openRequest=${sourceItemId}`;
      } else {
        linkUrl = `/hub?openTab=${CorporateViewTabs.Resources}&openRequest=${sourceItemId}`;
      }

      return <Link to={linkUrl}>Go to Resource Request</Link>;
    case ITEM_TYPES.WorkAssignmentListAttachment:
      if (incidentId) {
        linkUrl = `/iap/${incidentId}/dashboard?mode=future&formsView=working&phase=5&openWala=${encodeURIComponent(sourceItemId)}`;
      } else {
        linkUrl = `/iap/dashboard?mode=future&formsView=working&phase=5&openWala=${encodeURIComponent(sourceItemId)}`;
      }
      return <Link to={linkUrl}>View 204</Link>;
    default:
      return null;
  }
};

export default ReviewRequestedLink;
